import { Product } from 'pleinchamp-api-client';
import React, { FC } from 'react';
import { IconButton } from '@components/buttons/IconButton/IconButton.component';
import { ChartIcon } from '@components/icons/Chart.icon';
import { Text } from '@components/Text/Text.component';
import { PlcAccordion } from '@layout/components/PlcAccordion/PlcAccordion.component';
import { ElementComponents } from '@stocks/business/StocksTable.utils';

import styles from './StocksAccordionBody.module.scss';

export const StockDetailAccordionRow: FC<{
  elements: ElementComponents[];
  firstElement: ElementComponents;
  product: Product;
  onShowGraph?: (product: Product) => void;
}> = ({ elements, product, onShowGraph, firstElement }) => {
  function onClickGraph() {
    if (onShowGraph) {
      return onShowGraph(product);
    }
    return undefined;
  }
  function structureTitreMobile() {
    const conformation = product.cattleDetail?.conformation || '';
    const sex = product.cattleDetail?.sex || '';
    const weight = product.cattleDetail?.weight || '';

    // Rien de null
    if (conformation !== '' && sex !== '' && weight !== '') {
      return `${conformation} / ${sex} / ${weight}`;
    }
    // conformation null
    if (conformation === '' && sex !== '' && weight !== '') {
      return `${sex} / ${weight}`;
    }
    // sex null
    if (conformation !== '' && sex === '' && weight !== '') {
      return `${conformation} / ${weight}`;
    }
    // weight null
    if (conformation !== '' && sex !== '' && weight === '') {
      return `${conformation} / ${sex}`;
    }
    // sex et weight de null
    if (conformation !== '' && sex === '' && weight === '') {
      return `${conformation}`;
    }
    // conformation et weight de null
    if (conformation === '' && sex !== '' && weight === '') {
      return `${sex}`;
    }
    // conformation et sex de null
    if (conformation === '' && sex === '' && weight !== '') {
      return `${weight}`;
    }

    return '';
  }
  function structureRaceMobile(): string {
    const sliceLimit = 40;
    const race = (firstElement.raw as string) || '';

    return race.length > sliceLimit ? `${race.slice(0, sliceLimit)}...` : race;
  }
  const raceTitle = structureRaceMobile();

  const titleComponent = (
    <div className={styles["stocks-accordion-title"]}>
      <Text tag="h3" variant="h6">
        {raceTitle}
      </Text>
      <Text tag="h3" variant="h6">
        {structureTitreMobile()}
      </Text>
    </div>
  );

  const graphButton = (
    <div className="full-width ">
      <IconButton className={styles["accordion-body-graph-icon"]} onClick={onClickGraph}>
        <ChartIcon />
        <Text i18nKey="common.see-chart" tag="span" variant="small" />
      </IconButton>
    </div>
  );
  const body = (
    <div className={styles["stocks-accordion-body"]}>
      {elements.map(element => element.mobile)}
      {graphButton}
    </div>
  );

  return (
    <PlcAccordion key={product.id} titleComponent={titleComponent}>
      {body}
    </PlcAccordion>
  );
};
